import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqData = [
  {
    question: "Quels documents faut-il pour souscrire ?",
    answer: "Une pièce d’identité valide et quelques informations personnelles suffisent. Le processus est entièrement en ligne et ne prend que quelques minutes."
  },
  {
    question: "Quand ma couverture prend-elle effet ?",
    answer: "Dès la validation de votre souscription et du paiement, votre protection s’active immédiatement. Vous êtes couvert sans délai."
  },
  {
    question: "Puis-je ajouter ma famille à mon assurance ?",
    answer: "Oui. Vous pouvez ajouter conjoint(e) et enfants à tout moment, avec des tarifs avantageux et des garanties adaptées à chacun."
  },
  {
    question: "Comment se passent les remboursements ?",
    answer: "Ils sont traités rapidement et de manière transparente. Vous suivez chaque étape directement depuis votre espace client."
  }
];

export default function Accordion() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="space-y-2">
      {faqData.map((item, index) => (
        <div key={index} className="pb-4">
          <button
            className="w-full text-left py-3 text-lg font-semibold text-secondary flex justify-between items-center"
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            {item.question}
            <span className={`transform transition ${openIndex === index ? 'rotate-180' : ''} border-2 border-black/50 rounded-full p-1`}>
              <ChevronDown size={24}/>
            </span>
          </button>
          <div className={`mt-2 text-[#212529] pt-3 overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 border-t border-gray-100' : 'max-h-0'}`}>
            <p className='text-start'>{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
}